import { configureStore, ConfigureStoreOptions } from '@reduxjs/toolkit';
import thunkMiddleware from 'redux-thunk';
import { persistStore, persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducer from './slices';

export const getStore = (
  persistSuffix: string,
  preloadedState?: ConfigureStoreOptions<RootState>['preloadedState'],
) => {
  const persistConfig = {
    key: 'root' + persistSuffix,
    storage,
    whitelist: ['cart'],
  };

  const store = configureStore({
    reducer: persistCombineReducers(persistConfig, reducer),
    preloadedState,
    devTools: true,
    middleware: (getDefault) =>
      getDefault({
        serializableCheck: false,
      }).concat(thunkMiddleware),
  });

  let reconciledState = false;

  const persistor = persistStore(store, null, () => {
    if (!reconciledState) {
      store.dispatch({ type: 'RECONCILE_PERSISTED_STATE' });
      reconciledState = true;
    }
  });

  return {
    store,
    persistor,
  };
};

export type RootState = {
  [P in keyof typeof reducer]: ReturnType<(typeof reducer)[P]>;
};
export type AppDispatch = ReturnType<typeof getStore>['store']['dispatch'];
